var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component__cat-editor--sentence-source-symbol flex-center",class:_vm.classNames},[_vm._v("\n  "+_vm._s(_vm.textContent)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }